<!-- 角色管理 -->

<template>
    <el-container class="Wrapper">
        
        <el-container class="container">
            
            <el-main class="main">
                <div class="main_item">
                    <div class="role">
                        <el-table :data="manage" style="width: 100%" height="400" v-loading="loading"
                            element-loading-text="加载中，请稍后...">
                            <el-table-column  prop="name" label="管理员用户名" width="150" />
                            <el-table-column prop="description" label="权限" width="600" />
                            <el-table-column label="开启" width="120">
                                <template #default="scope">
                                    <el-switch size="large" active-text="" inactive-text=""
                                        v-model="scope.row.roleState"
                                        @change="admin(scope.row.id, scope.row.roleState)" />
                                </template>
                            </el-table-column>
                            <el-table-column  label="操作" width="120">
                                <template #default="scope">
                                    <el-button type="primary"  @click="edit(scope.row.id)">编辑</el-button>
                                    <el-button type="danger"  @click="del(scope.row.id)">删除</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                    <div v-if="showModals" class="modal">
                        <div class="modals-content">
                            <span class="close" @click="toggleModals">&times;</span>
                            <span class="edadmin">修改管理员账号</span>
                            <el-form :model="form" label-width="auto" style="max-width: 300px">
                                <el-form-item label="账号名">
                                    <el-input v-model="form.name" />
                                </el-form-item>
                                <el-form-item label="账号">
                                    <el-input v-model="form.account" />
                                </el-form-item>
                                <el-form-item label="密码">
                                    <el-input v-model="form.password" />
                                </el-form-item>
                                <el-form-item label="所属门店">
                                    <el-select v-model="form.sysStoreId" placeholder="商品所属门店" @change="changeStore">
                                        <el-option v-for="item in stores" :key="item.id" :label="item.name"
                                            :value="item.id" />
                                        <el-option label="超管" value="0" />
                                    </el-select>
                                </el-form-item>
                                <el-form-item>
                                    <el-button type="primary" @click="confirm">确认</el-button>
                                    <el-button @click="cancellation">取消</el-button>
                                </el-form-item>
                            </el-form>
                        </div>
                    </div>
                    <div v-if="showModalse" class="modal">
                        <div class="modals-content">
                            <span class="close" @click="toggleModalse">&times;</span>
                            <span class="edadmin">新增角色账号</span>
                            <el-form :model="form" label-width="auto" style="max-width: 300px">
                                <el-form-item label="账号名">
                                    <el-input v-model="form.name" />
                                </el-form-item>
                                <el-form-item label="账号">
                                    <el-input v-model="form.account" />
                                </el-form-item>
                                <el-form-item label="密码">
                                    <el-input v-model="form.password" />
                                </el-form-item>
                                <el-form-item label="所属门店">
                                    <el-select v-model="form.sysStoreId" placeholder="商品所属门店" @change="changeStore">
                                        <el-option v-for="item in stores" :key="item.id" :label="item.name"
                                            :value="item.id" />
                                        <el-option label="超管" value="0" />
                                    </el-select>
                                </el-form-item>
                                <el-form-item>
                                    <el-button type="primary" @click="confirm">确认</el-button>
                                    <el-button @click="cancellation">取消</el-button>
                                </el-form-item>
                            </el-form>
                        </div>
                    </div>
                </div>
            </el-main>
        </el-container>
    </el-container>
</template>

<script setup>
import Menu from '../navbar/Menu.vue'
import LeftNav from '../navbar/LeftNav.vue'
import TopNav from '../navbar/TopNav.vue'
import { useRouter } from 'vue-router'
import { ElMessage, ElMessageBox } from 'element-plus'
import instance from '../network/storester.js'
import { ref, toRaw } from 'vue'

const manage = ref([])
const manages = ref(null)
const router = useRouter()
const loading = ref(true)
const showModals = ref(false)
const showModalse = ref(false)

instance.get('/api/adminRole/getRole')
    .then(response => {
        //console.log(response.data.data.id);
        manages.value = response.data.data
        //console.log(manages.value);
        for (let i = 0; i < manages.value.length; i++) {
            if (manages.value[i].roleState === 0) {
                manages.value[i].roleState = true
            } else {
                manages.value[i].roleState = false
            }
            if (manages.value[i].description.length > 0) {
                manages.value[i].description = manages.value[i].description.join(', ');
            }
            //console.log(manages.value[i].description.length);
        }


        //console.log(manages.value);
        manage.value = toRaw(manages.value)
        loading.value = false

    }).catch(error => {
        //console.log(error);
        ElMessage({
            showClose: true,
            message: '请登录',
            type: 'error',
        })
        router.push('./')
    })
const admin = (id, roleState) => {
    if (roleState === true) {
        roleState = 0
    } else {
        roleState = 1
    }
    instance.put(`/api/adminRole/updateRolePermission/Status?id=${id}&roleState=${roleState}`)
        .then(response => {
            if (roleState = 1) {
                ElMessage({
                    type: 'success',
                    message: '已开启',

                })
            } else {
                ElMessage({
                    type: 'error',
                    message: '已关闭',

                })
            }
            //console.log(response);
        }).catch(error => {
            //console.log(error);
            router.push('./')
        })
}

const form = ref({
    name: '',
    AccountNumber: '',
    password: '',
    sysStoreId: '',
})

const EditUser = ref([])
const EditUsers = ref(null)
const stores = ref([])
const storess = ref(null)
const edit = (id) => {
    showModals.value = !showModals.value;
    instance.get(``)
        .then(response => {
            //console.log(stores.value);
        })
        .catch(error => {
            ElMessage({
                showClose: true,
                message: '请重新登录',
                type: 'error',
            })
            router.push('./')
        })
}

const changeStore = () => {

}
//console.log(form.value);
const toggleModals = () => {
    showModals.value = !showModals.value;
};
const toggleModalse = () => {
    showModalse.value = !showModalse.value;
};
const confirm = () => {
    //console.log(form.value);
    instance.put(``)
        .then(response => {
            ElMessage({
                type: 'success',
                message: '编辑成功',

            })
            // window.location.reload()
        }).catch(error => {
            ElMessage({
                showClose: true,
                message: '编辑失败',
                type: 'error',
            })
        })
}
const cancellation = () => {
    showModals.value = false;
}
const del = (id) => {
    ElMessageBox.confirm(
        '您确定要删除角色吗?',
        '提示',
        {
            confirmButtonText: '确认',
            cancelButtonText: '取消',
            type: 'warning',
        }
    )
        .then(() => {
            instance.delete(`/api/adminRole/deleteRole?id=${id}`)
                .then(response => {
                    ElMessage({
                        type: 'success',
                        message: '删除成功',

                    })
                }).catch(error => {
                    //console.log(error);
                    ElMessage({
                        type: 'error',
                        message: '删除失败',

                    })
                    router.push('/')
                })
            window.location.reload()
        })
        .catch(() => {
            ElMessage({
                type: 'info',
                message: '取消删除',
            })
        })

}
const NewRole = () => {
    showModalse.value = !showModalse.value;
}
</script>

<style>
.leftnavbar {
    position: fixed;
    top: 0;
    left: 0;
    width: 15vw;
    height: 100vh;
    background-color: #545c64;
}

.container {
    position: fixed;
    top: 0;
    left: 15vw;
}

.container_top {
    width: 85vw;
    height: 10vh;
    background-color: #545c64;
}

.main {
    position: fixed;
    top: 10vh;
    left: 15vw;
    width: 85vw;
    height: 90vh;
}

.role {
    width: 85vw;
    height: 100vh;
    /* margin-top: 5vh; */
}


.modals-content {
    background-color: #fefefe;
    margin: 8% 15% 15% 35%;
    padding: 20px;
    border: 1px solid #888;
    width: 400px;
    left: 50vw;
}

.close {
    color: #aaaaaa;
    float: right;
    font-size: 28px;
    font-weight: bold;
}

.close:hover,
.close:focus {
    color: #000;
    text-decoration: none;
    cursor: pointer;
}

.modal .edadmin {
    font-size: 16px;
}


.newrole {
    margin-left: 70vw;
}
</style>